import { render, staticRenderFns } from "./ScreenRetorno.vue?vue&type=template&id=78b0c1ba&scoped=true&"
import script from "./ScreenRetorno.vue?vue&type=script&lang=js&"
export * from "./ScreenRetorno.vue?vue&type=script&lang=js&"
import style0 from "./ScreenRetorno.vue?vue&type=style&index=0&id=78b0c1ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b0c1ba",
  null
  
)

export default component.exports